const CONFETTI_ROOT_ID = 'mm-tour-confetti'
const CONFETTI_PIECE_COUNT = 24
const CLEAR_ACTIVE_MS = 3400

export function triggerTourConfetti() {
	let confettiRoot = document.getElementById(CONFETTI_ROOT_ID)
	if (!confettiRoot) {
		confettiRoot = document.createElement('div')
		confettiRoot.id = CONFETTI_ROOT_ID
		confettiRoot.className = 'mm-tour-confetti'
		for (let i = 1; i <= CONFETTI_PIECE_COUNT; i += 1) {
			const isLeftCone = i <= 12
			const coneIndex = isLeftCone ? i : i - 12
			const laneOffset = (coneIndex - 6.5) * 24
			const jitterX = (Math.random() - 0.5) * 80
			const jitterY = Math.random() * 90
			const piece = document.createElement('span')
			piece.className = `mm-tour-confetti__piece mm-tour-confetti__piece--${(i % 3) + 1} ${
				isLeftCone ? 'mm-tour-confetti__piece--left' : 'mm-tour-confetti__piece--right'
			}`
			piece.style.setProperty('--mm-start-x', isLeftCone ? '10vw' : '90vw')
			piece.style.setProperty('--mm-start-y', '108vh')
			piece.style.setProperty(
				'--mm-cone-offset-x',
				`${laneOffset * (isLeftCone ? 1 : -1) + jitterX}px`
			)
			piece.style.setProperty(
				'--mm-cone-offset-y',
				`${Math.max(85, Math.abs(laneOffset) * 0.9) + jitterY}px`
			)
			piece.style.setProperty('--mm-rotate-end', `${420 + coneIndex * 18}deg`)
			piece.style.setProperty('--mm-delay', `${(coneIndex - 1) * 0.04 + Math.random() * 0.14}s`)
			confettiRoot.appendChild(piece)
		}
		document.body.appendChild(confettiRoot)
	}

	const activeStep = document.querySelector('.shepherd-element.shepherd-enabled, .shepherd-element')
	if (activeStep instanceof HTMLElement) {
		const rect = activeStep.getBoundingClientRect()
		const targetX = rect.left + rect.width / 2
		const targetY = rect.top + rect.height / 2
		confettiRoot.style.setProperty('--mm-target-x', `${targetX}px`)
		confettiRoot.style.setProperty('--mm-target-y', `${targetY}px`)
	}

	confettiRoot.classList.remove('is-active')
	void confettiRoot.offsetWidth
	confettiRoot.classList.add('is-active')
	window.setTimeout(() => {
		confettiRoot?.classList.remove('is-active')
	}, CLEAR_ACTIVE_MS)
}
